/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontCallButton_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontSocial_viewer$ref: FragmentReference;
export type StorefrontSocial_viewer = {|
  +$fragmentRefs: StorefrontCallButton_viewer$ref,
  +$refType: StorefrontSocial_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontSocial_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontCallButton_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5d99f3cde3423e815e63e88579c0b4c1';
module.exports = node;
